const serviceName = "/UserInformation";
const personnelInfoServiceName = "/PersonnelInfo";

export function userInformationService(http) {
    return {
        getUserGeneralInformation: (userProfileId) => {
            var parameter = {
                UserId: userProfileId,
            };

            return http.post(serviceName +"/GetUserGeneralInformation",parameter);
        },
        getPersonnelByTypeForTimesheetBultApprovalAsync : async (type, personnelCode, emplacementCode, emplacementSubCode,
            generalPostCategoryCode, costCenterCode, discipline, activity, dateFrom, dateTo) => {
            var parameters = {
                personnelType: parseInt(type),
                personnelCode,
                emplacementCode,
                emplacementSubCode,
                generalPostCategoryCode,
                costCenterCode,
                disciplineCode: discipline,
                activityCode: activity,
                from: dateFrom,
                to: dateTo
            }

            return await http.post(personnelInfoServiceName + "/GetPersonnelGeneralInformationAsync", parameters);
        },
        getManagers: () => {
            return http.get(personnelInfoServiceName +"/GetManagers");
        }
    }
}

